import { useReducer } from 'react';
import {
  BaseUrlStoreKind,
  BaseUrlStoreType,
  defaultReportYears,
  possibleBaseUrls,
  ReportYears,
} from 'src/store/baseUrl/baseUrlStore.types';
import BaseUrlStore, { INITIAL_BASE_URL } from 'src/store/baseUrl/baseUrlStore';
import { Language } from 'src/store/language/languageStore.types';

export interface BaseUrlHook {
  state: BaseUrlStoreType;
  actions: {
    setBaseUrlLanguage: (language: Language) => void;
    initBaseUrl: (path: string) => void;
    getLanguageByPath: (path: string) => Language;
    getReportStartYearAndEndYear: () => ReportYears | undefined;
  };
}

const useBaseUrlHook = (): BaseUrlHook => {
  const [state, dispatch] = useReducer(BaseUrlStore, INITIAL_BASE_URL);

  const setBaseUrlLanguage = (language: Language): void => {
    dispatch({
      type: BaseUrlStoreKind.INITIAL,
      payload:
        possibleBaseUrls.find(
          baseUrl =>
            baseUrl.language === language &&
            baseUrl.isYearView === state.isYearView
        ) ?? possibleBaseUrls[0],
    });
  };

  const getLanguageByPath = (path: string): Language => {
    const result =
      possibleBaseUrls.find(baseUrl => baseUrl.path === path) ??
      possibleBaseUrls[0];
    return result.language;
  };

  const initBaseUrl = (path: string): void => {
    dispatch({
      type: BaseUrlStoreKind.INITIAL,
      payload:
        possibleBaseUrls.find(baseUrl => baseUrl.path === path) ??
        possibleBaseUrls[0],
    });
  };

  const getReportStartYearAndEndYear = (): ReportYears => {
    if (state.isYearView) {
      return defaultReportYears;
    }
    return undefined;
  };

  return {
    state,
    actions: {
      setBaseUrlLanguage,
      initBaseUrl,
      getLanguageByPath,
      getReportStartYearAndEndYear,
    },
  };
};

export default useBaseUrlHook;
